(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hibana-inventory-status"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function readJson(root, selector, fallback) {
      const source = root.querySelector(selector);
      if (!source) return fallback;

      try {
        return JSON.parse(source.textContent);
      } catch (error) {
        return fallback;
      }
    }

    function getVariantId() {
      const productFormInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (productFormInput && productFormInput.value) {
        return String(productFormInput.value);
      }

      const url = new URL(window.location.href);
      return url.searchParams.get('variant');
    }

    function resolveStatus(variant, override, lowStockThreshold) {
      if (override && override !== 'auto') {
        return override;
      }

      if (!variant) {
        return 'not_available';
      }

      const quantity = Number(variant.inventory_quantity || 0);

      if (!variant.inventory_management) {
        return 'in_stock';
      }

      if (quantity > 0) {
        if (quantity <= lowStockThreshold) {
          return 'low_stock';
        }

        return 'in_stock';
      }

      if (variant.inventory_policy === 'continue') {
        return 'pre_order';
      }

      if (variant.available) {
        return 'in_stock';
      }

      return 'out_of_stock';
    }

    function init(root) {
      if (root.dataset.hibanaInventoryInitialized === 'true') return;

      const variantData = readJson(root, '[data-hibana-inventory-variants]', []);
      const copy = readJson(root, '[data-hibana-inventory-copy]', {});
      const label = root.querySelector('.hibana-inventory-status__label');
      const message = root.querySelector('.hibana-inventory-status__message');
      const override = root.dataset.statusOverride || 'auto';
      const lowStockThreshold = Number(root.dataset.lowStockThreshold || 5);
      let lastVariantId = null;

      function update() {
        const variantId = getVariantId();
        const variant = variantData.find((item) => String(item.id) === String(variantId)) || variantData[0];
        const status = resolveStatus(variant, override, lowStockThreshold);

        if (String(variantId) === String(lastVariantId) && status === root.dataset.currentStatus) {
          return;
        }

        const content = copy[status] || copy.not_available;
        if (!content) return;

        lastVariantId = variantId;
        root.dataset.currentStatus = status;
        root.style.setProperty('--hibana-stock-current', content.color);
        if (label) label.textContent = content.label;
        if (message) message.textContent = content.message;
      }

      update();
      document.addEventListener('change', update);
      document.addEventListener('variant:change', update);
      document.addEventListener('product:variant-change', update);
      window.setInterval(update, 500);
      root.dataset.hibanaInventoryInitialized = 'true';
    }

    function placeInProductMain(root) {
      const productForm = document.querySelector('form[action*="/cart/add"]');
      const productInfo = productForm?.closest('.t4s-product__info-container') || document.querySelector('.t4s-product__info-container');
      const oldStatus = productInfo?.querySelector('.t4s-liquid_custom_liquid_UhMfUm, [class*="liquid_custom_liquid_UhMfUm"]') || document.querySelector('.t4s-liquid_custom_liquid_UhMfUm, [class*="liquid_custom_liquid_UhMfUm"]');
      const hurryBlock = productInfo?.querySelector('[class*="inventory_qty_xFtete"], .t4s-inventory_qty') || document.querySelector('[class*="inventory_qty_xFtete"], .t4s-inventory_qty');

      if (oldStatus && oldStatus.parentNode && oldStatus !== root && !oldStatus.contains(root)) {
        oldStatus.parentNode.insertBefore(root, oldStatus);
        oldStatus.style.display = 'none';
        return;
      }

      if (hurryBlock && hurryBlock.parentNode && hurryBlock !== root && !hurryBlock.contains(root)) {
        hurryBlock.parentNode.insertBefore(root, hurryBlock.nextSibling);
        return;
      }

      if (productInfo && root.parentNode !== productInfo) {
        productInfo.appendChild(root);
      }
    }

    function initAll() {
      document.querySelectorAll('.hibana-inventory-status').forEach((root) => {
        placeInProductMain(root);
        init(root);
      });
    }

    initAll();
    document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hibana-technology-explorer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (explorer) => {
      if (explorer.dataset.hibanaExplorerReady) return;
      explorer.dataset.hibanaExplorerReady = 'true';
      explorer.querySelectorAll('[data-hibana-explorer-tab]').forEach((tab) => {
        tab.addEventListener('click', () => {
          const id = tab.dataset.hibanaExplorerTab;
          explorer.querySelectorAll('[data-hibana-explorer-tab]').forEach((item) => {
            const selected = item === tab;
            item.classList.toggle('is-active', selected);
            item.setAttribute('aria-selected', String(selected));
          });
          explorer.querySelectorAll('[data-hibana-explorer-panel]').forEach((panel) => {
            const selected = panel.dataset.hibanaExplorerPanel === id;
            panel.hidden = !selected;
            panel.classList.toggle('is-active', selected);
          });
        });
      });
    };
    const initialiseAll = (scope = document) => scope.querySelectorAll('[data-hibana-technology-explorer]').forEach(initialise);
    initialiseAll();
    document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hibana-technology-nav"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (nav) => {
      if (nav.dataset.hibanaNavigationReady || !('IntersectionObserver' in window)) return;
      const links = [...nav.querySelectorAll('a[href^="#"]')];
      const targets = links.map((link) => document.getElementById(link.getAttribute('href').slice(1))).filter(Boolean);
      if (!targets.length) return;
      nav.dataset.hibanaNavigationReady = 'true';
      const observer = new IntersectionObserver((entries) => {
        const visible = entries.filter((entry) => entry.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (!visible) return;
        links.forEach((link) => link.classList.toggle('is-active', link.getAttribute('href') === `#${visible.target.id}`));
      }, { rootMargin: '-35% 0px -55% 0px', threshold: [0.01, 0.2, 0.5] });
      targets.forEach((target) => observer.observe(target));
    };
    const initialiseAll = (scope = document) => scope.querySelectorAll('[data-hibana-technology-nav]').forEach(initialise);
    initialiseAll();
    document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vehicle-upgrades-finder"] && !Shopify.designMode) return;
  try {
    
(()=>{const q=(e,s)=>e.querySelector(s),o=(s,a,t='n')=>{s.disabled=!a.length;a.forEach(i=>s.add(new Option(i[t]||i.n||i.h,i.k)))},ph=(e,k,d)=>e.dataset[k]||d;document.querySelectorAll('[data-vehicle-finder]').forEach(e=>{if(e.dataset.ready)return;e.dataset.ready=1;let d=JSON.parse(q(e,'[data-json]').textContent||'{}'),f=q(e,'[data-form]'),ma=q(e,'[data-make]'),mo=q(e,'[data-model]'),yr=q(e,'[data-year]'),va=q(e,'[data-variant]'),m=q(e,'[data-message]'),r=(s,t)=>{s.innerHTML='';s.add(new Option(t,''))},msg=t=>{m.textContent=t;m.hidden=!t},u=h=>h?e.dataset.prefix+'/'+h:'';o(ma,(d.makes||[]).sort((a,b)=>(a.n||'').localeCompare(b.n||'')));ma.onchange=()=>{msg('');r(mo,ph(e,'modelPlaceholder','Choose model'));r(yr,ph(e,'yearPlaceholder','Choose year'));r(va,ph(e,'variantPlaceholder','Choose variant'));yr.disabled=va.disabled=1;o(mo,(d.models||[]).filter(i=>i.mk===ma.value).sort((a,b)=>(a.n||'').localeCompare(b.n||'')))};mo.onchange=()=>{msg('');r(yr,ph(e,'yearPlaceholder','Choose year'));r(va,ph(e,'variantPlaceholder','Choose variant'));va.disabled=1;o(yr,(d.years||[]).filter(i=>i.mk===mo.value).sort((a,b)=>(a.n||'').localeCompare(b.n||'')))};yr.onchange=()=>{msg('');r(va,ph(e,'variantPlaceholder','Choose variant'));o(va,(d.variants||[]).filter(i=>i.yk===yr.value).sort((a,b)=>(a.n||'').localeCompare(b.n||'')))};f.onsubmit=t=>{t.preventDefault();let make=(d.makes||[]).find(i=>i.k===ma.value),v=(d.variants||[]).find(i=>i.k===va.value);if(!make||!mo.value||!yr.value||!v)return msg(ph(e,'validationMessage','Choose a make, model, year, and variant.'));location.href=v.u||u(make.h)}})})();

  } catch(e) { console.error(e); }
})();
})();
